const isProd = process.env.NODE_ENV === 'production';

const trackView = (event = null, options = {}) => {
    if (isProd) {
        let dataLayer = (window.dataLayer = window.dataLayer || []);
        dataLayer.push({
            event: event || 'content-view',
            ...options
        });
    }
};

export const defineTrackviewOptions = (user, session) => {
    return {
        userid: user.id,
        session_id: session.id,
        session_theme: session.theme,
        session_type: session.type,
        session_online: session.type === 'live' ? true : false,
        session_start: session.startedAt
            ? session.startedAt
            : session.createdAt,
        session_planned: session.startedAt ? true : false,
        business: user.business?.name,
        videoname: session.title,
        instructor: session.instructor?.fullName
            ? session.instructor.fullName
            : 'No instructor'
    };
};

export default trackView;
